export default __webpack_public_path__ + "static/media/logo_innotech_black.23b27e61.png";